<div class="container">
  <mat-horizontal-stepper [linear]="!hasInspectionActive" #stepper>
    <mat-step [completed]="equipmentSelect" [editable]="stepsEditable">
      <ng-template class="font" matStepLabel>Equipos</ng-template>
      <app-equipment-table
        class="w-100"
        (clickRow)="clickFilaEquipos($event)"
        [equipment]="equipo"
        (continue)="onContinueEquipment()"
      >
      </app-equipment-table>
    </mat-step>

    <mat-step [completed]="formSelect" [editable]="stepsEditable">
      <ng-template class="font" matStepLabel>Formularios</ng-template>      
      <data-table
        *ngIf="haveInspectionsForms"
        class="w-100"
        [title]=""
        [columns]="inspectionFormByEquipmentColumns"
        [configuration]="inspectionFormByEquipmentConfiguration"
        [reloadTable]="reloadTableIFByEquipment"
        [params]="paramsInspectionFormByEquipment"
        [url]="
          EndpointDictionary.InspectionForm.INSPECTION_FORM_BY_EQUIPMENT_TABLE
        "
        (internalData)="dataFromTable($event)"
        (clickRow)="clickInspeccionForm($event)"
      ></data-table>
      <div style="display: flex; flex-direction: row; justify-content: center">
        <button
          type="button"
          style="width: 70%; margin-top: 30px; align-self: center"
          color="primary"
          class="button-save mat-elevation-z5"
          mat-raised-button
          [disabled]="!haveInspectionsForms"
          (click)="inspectionForm ? initHistoricalInspection() : errorMessage()"
        >
          Continuar
        </button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template class="font" matStepLabel>Preguntas</ng-template>
      <div class="d-flex flex-column align-items-center mt-2">
        <app-button-label [labelsEdit]="labelsForm"> </app-button-label>
      </div>

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        "
      >
        <div class="row-item" style="flex: 0 0 60%">
          <mat-form-field>
            <mat-label>Fecha</mat-label>
            <input
              matInput
              [matDatepicker]="pickerCompra"
              autocomplete="off"
              matInput
              required
              [(ngModel)]="fecha"
              [disabled]="!showDate"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerCompra">
            </mat-datepicker-toggle>
            <mat-datepicker
              #pickerCompra
              [touchUi]="movil ? true : false"
            ></mat-datepicker>
          </mat-form-field>
        </div>

        <div
          style="
            flex: 0 0 40%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          "
        >
          <button
            *ngIf="questionsBody.length > 0 && autoComplete"
            class="mb-4 mr-4"
            (click)="autoComplit()"
            mat-mini-fab
            color="primary"
            matTooltip="Autocompletar"
          >
            <mat-icon>autorenew</mat-icon>
          </button>

          <button
            class="mb-4"
            mat-mini-fab
            color="warn"
            (click)="cancelInspectionForm()"
            matTooltip="Eliminar inspección"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>

      <mat-accordion class="example-headers-align">
        <mat-expansion-panel
          class="panel"
          [style]="colorPanel[i]"
          *ngFor="let data of questionsBody; let i = index"
          [expanded]="expanded[i]"
        >
          <mat-expansion-panel-header>
            <mat-panel-title [style]="colorPanel[i]" class="title">
              <h5 class="no-spacing">
                {{data.question}}
              </h5></mat-panel-title>
          </mat-expansion-panel-header>

          <div
            style="
              display: flex;
              justify-content: space-around;
              flex-wrap: wrap;
              width: 100%;
            "
          >
            <div
              style="width: 100%"
              class="first-row"
              *ngIf="data.responses?.length == 1"
            >
              <div
                *ngIf="data.responses[0] == 'Texto'"
                class="row-item"
                style="display: flex; flex-direction: column"
              >
                <mat-form-field>
                  <input
                    [(ngModel)]="response[i].response"
                    autocomplete="off"
                    type="text"
                    matInput
                    required
                    #descripcion
                    maxlength="255"
                  />
                  <mat-hint>{{ descripcion.value.length }}/255</mat-hint>
                </mat-form-field>

                <div class="w-100 d-flex flex justify-content-center p-4">
                  <button
                    style="margin: 0 10px 0 10px; width: 200px; height: 5%"
                    (click)="textResponse(i, data)"
                    mat-raised-button
                  >
                    Enviar
                  </button>
                </div>
              </div>

              <div
                *ngIf="data.responses[0] == 'Numero'"
                class="d-flex flex-column col-12 justify-content-around"
              >
                <div
                  class="d-flex flex-column flex-sm-row col-12 justify-content-center p-0"
                >
                  <mat-form-field class="col-12 col-sm-6 my-2">
                    <input
                      [(ngModel)]="response[i].response"
                      autocomplete="off"
                      type="string"
                      matInput
                      required
                      #odometer
                      oninput="this.value = this.value.slice(0,8)"
                      placeholder="Ingrese nuevo valor"
                    />
                    <mat-hint>{{ odometer.value.length }} / 9</mat-hint>
                  </mat-form-field>

                  <mat-form-field class="col-12 col-sm-6 my-2">
                    <input
                      [value]="currentOdometer"
                      appThousandSeparator
                      matInput
                      placeholder="Valor actual"
                      readonly
                      #currentodometer
                    />
                  </mat-form-field>
                </div>

                <div class="w-100 d-flex flex justify-content-center p-4">
                  <button
                    style="margin: 0 10px 0 10px; width: 200px; height: 5%"
                    (click)="textResponse(i, data, true)"
                    mat-raised-button
                  >
                    Enviar
                  </button>
                </div>
              </div>

              <div
                *ngIf="data.responses[0] == 'Fecha'"
                class="d-flex flex-column col-12 justify-content-around"
              >
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="pickerFecha"
                    autocomplete="off"
                    required
                    [(ngModel)]="response[i].response"
                    placeholder="Seleccione una fecha"
                    (dateChange)="dateResponse(i, data)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerFecha"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #pickerFecha
                    [touchUi]="movil ? true : false"
                  ></mat-datepicker>
                </mat-form-field>
              </div>

              <div
                *ngIf="data.responses[0] == 'Imagen'"
                class="d-flex flex-column col-12 justify-content-around"
              >
                <div
                  class="d-flex flex-column col-12 align-items-centerr p-0"
                >
                  <div class="containerPhotos mb-4">
                    <file-input
                      [params]="fileInputs[i]"
                      (fileSave)="fileSave($event, i, data)"
                    ></file-input>
                  </div>
                             
                </div>
              </div>
            </div>

            <div *ngFor="let res of data.responses; let j = index">
              <button
                *ngIf="data.responses.length > 1"
                style="margin: 5px; width: 130px"
                (click)="selectResponse(res, i, data, j)"
                mat-raised-button
                [color]="color[i][j]"
              >
                {{ res }}
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div
        style="
          display: flex;
          justify-content: center;
          width: 100%;
          margin: 30px 0 30px 0;
        "
      >
        <button
          *ngIf="questionsBody.length > 0"
          style="width: 60%"
          (click)="Finalize()"
          mat-raised-button
          color="warn"
        >
          Finalizar
        </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
